'use client'

import { useCachedCart } from '@/hooks/useCachedCart'
import { useCartChangeTracking } from '@/hooks/useCartChangeTracking'

export const CartChangeTracker = () => {
  useCartChangeTracking(useCachedCart())

  return null
}
